import styled from "styled-components";

/**
 * Inherited settings wrapper
 */
export const InheritedSettingsWrapper = styled.div`
  position: relative;
  max-width: 50rem;
`;